import styled from 'styled-components'
import {
  background,
  center,
  hFlex,
  overlay,
  square,
  vFlex,
} from '../../../../../../../../../../Styles/style-helpers'
import { H3, H5 } from '../../../../../../../../../../Styles/typography'
import speedIcon from '../../../../../../../../../../Assets/Icons/Recorded/speed.svg'
import unlockIcon from '../../../../../../../../../../Assets/Icons/Recorded/unlock.svg'
import forumIcon from '../../../../../../../../../../Assets/Icons/Recorded/forum.svg'
import playIcon from '../../../../../../../../../../Assets/Icons/Recorded/play.svg'
import { motion } from 'framer-motion'

export const RegistrationEl = styled(motion.div)`
  ${hFlex};
  width: 100%;
  font-size: ${({ expanded }) => (!expanded ? '0.85em' : '1em')};

  .fee {
    flex: ${({ expanded }) => (!expanded ? 'unset' : 1)};;
    ${hFlex};
    justify-content: flex-start;
    margin-right: 2em;

    .original {
      ${vFlex};

      .originalAmount {
        position: relative;

        &:after {
          content: "";
          width: 100%;
          ${center};
          height: 1px;
          display: block;
          background: black;
        }
      }
    }

    .final {
      margin-left: 1em;
    }

    span, h4, p {
      white-space: nowrap;
    }

  }

  .actions {
    display:flex;
    gap: 4px;

    .defaultButton {
      font-size: 1.125em;
      font-weight: normal;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }
}
`

export const HeaderEl = styled(motion.div)`
  position: sticky;
  top: 2em;
  margin: 2em 2em 1em;
  z-index: 15;
`

export const AboutEl = styled.div`
  padding: ${({ expanded }) => (expanded ? `1em 1em 6.5em` : `1em 1em`)};
  border-radius: 1em;
  background: #f7f7f7;
  position: relative;
  ${hFlex};
  align-items: flex-start;
  justify-content: flex-start;
  transition: all 150ms ease;

  .video {
    position: relative;
    width: 10em;
    margin-right: 0.5em;

    video {
      border-radius: 0.25em;
      width: 100%;
    }

    .vid-container {
      position: relative;

      .cover {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        border-radius: 0.25em;

        .playIcon {
          ${center};
          ${square('2.5em')};
          cursor: pointer;

          svg {
            height: 100%;
            width: 100%;
            color: white;
          }
        }
      }
    }
  }

  .info {
    width: calc(100% - 35em);
    min-width: calc(100% - 40em);
    max-width: calc(100% - 40em);
    margin: 0.5em ${({ expanded }) => (expanded ? `13.5em` : `2em`)} 0 2em;

    ${H3} {
      letter-spacing: 0.0125em;
      line-height: 1.3;
      width: 100%;
      margin-bottom: ${({ expanded }) => (expanded ? `0.5em` : `0.125em`)};
    }

    ${H5} {
      letter-spacing: 0.0125em;

      a {
        font-weight: bold;
      }
    }
  }

  .right {
    margin: 1em 0;
    ${hFlex};
    justify-content: flex-end;
    width: 25em;
    max-width: 25em;
    min-width: 25em;

    ${RegistrationEl} {
      justify-content: flex-end;
      white-space: nowrap;
    }

    .rating {
      font-size: 1.125em;
      margin-right: 1em;

      .rating {
        pointer-events: none;
      }
    }
  }
`

export const OverviewEl = styled(motion.div)`
  ${hFlex};
  justify-content: flex-start;
  align-items: unset;
  width: 100%;
  padding-left: 3em;
  transform: translate(0, -4.5em) !important;

  .video {
    position: relative;
    width: calc(100% - 32em);

    .vid-container {
      position: relative;
      width: 100%;
      padding-top: 56.25%;

      video {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-radius: 0.75em;
        width: 100%;
      }

      .cover {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        border-radius: 0.75em;

        .playIcon {
          ${center};
          ${square('5em')};
          cursor: pointer;

          svg {
            height: 100%;
            width: 100%;
            color: white;
          }
        }
      }
    }
  }

  .right {
    ${vFlex};
    align-items: unset;
    padding-left: 2em;
    flex: 1;

    .highlights {
      flex: 1;
      ${vFlex};
      justify-content: space-around;
      align-items: flex-start;
      list-style-type: none;
      border-bottom: 1px solid #e7e7e7;
      padding: 5em 0 0.5em;
      margin-bottom: 1.5em;

      li {
        margin: 0.75em 0;
        ${hFlex};
        justify-content: flex-start;

        span {
          ${square('1em')};
          margin-right: 1em;

          &.speed {
            ${background(speedIcon, 'contain')}
          }

          &.unlock {
            ${background(unlockIcon, 'contain')}
          }

          &.play {
            ${background(playIcon, 'contain')}
          }

          &.forum {
            ${background(forumIcon, 'contain')}
          }
        }
      }
    }
  }
`

export const ShareEl = styled.div`
  position: relative;
  background: white;
  width: 50vw;
  height: 20em;
  ${center};
  ${vFlex};
  border-radius: 0.5em;
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.5);

  .close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 1em;
  }

  .separator {
    width: 5em;
    height: 1px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.25);
    margin: 2em 0;
  }

  .link {
    ${hFlex};
    width: 100%;
    margin: 0 2em 2em;

    .url {
      background: #e7e7e7;
      padding: 1em;
      margin-right: 1em;
      border-radius: 0.5em;
    }
  }

  .shareButtons {
    ${hFlex};
    justify-content: center;

    & > button {
      margin: 0 2em;
    }
  }
`

export const RegistrationModalEl = styled.div`
  ${overlay};
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  ${vFlex};

  & > div {
    background: white;
    width: 65em;
    padding: 2em;
    max-width: 90vw;
    border-radius: 1em;
    ${vFlex};

    & > h3 {
      font-weight: bold;
      margin-bottom: 0.15em;
    }

    & > p {
      margin-bottom: 1.5em;
      font-size: 1.125em;
    }

    .options {
      ${hFlex};
      justify-content: space-between;
      align-items: unset;

      .type {
        ${vFlex};
        align-items: unset;
        width: 48%;
        border: 1px solid #e7e7e7;
        border-radius: 1em;
        padding: 1.5em;

        .full-height {
          height: 100%;
          flex: 1;
        }

        h4 {
          font-weight: 500;
          width: 100%;
          border-bottom: 1px solid #e7e7e7;
          padding-bottom: 0.5em;
          margin-bottom: 1em;
        }

        p {
          line-height: 1.33;
          color: #444;
        }

        button {
          width: 100%;
          font-weight: bold;
          margin-top: 1em;
          font-size: 1.125em;
        }

        ul {
          margin-top: 1em;
          padding-left: 1.5em;
          color: #444;

          li {
            margin: 0.5em 0;
          }
        }
      }
    }

    .fee {
      position: relative;
      ${vFlex};
      align-items: flex-start;
      margin: 1em 0;

      .original {
        ${hFlex};

        .originalAmount {
          position: relative;
          margin-right: 0.5em;

          &:after {
            content: '';
            width: 100%;
            ${center};
            height: 1px;
            display: block;
            background: black;
          }
        }
      }

      .final {
        white-space: nowrap;
      }

      span,
      h4,
      p {
        white-space: nowrap;
      }
    }
  }
`
